import React from 'react';
import Page from '../components/Page';
import {
  Card,
  CardBody,
  Modal,
  Row, Col,
  Button,
  Table
} from 'reactstrap';
import { MdDone, MdClear, MdCheck, MdClose } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import axios from 'axios';
import moment from 'moment-timezone';
import StorageService from '../services/StorageService';
import PosLicensingTable from '../components/PosLicensingTable';
import PosLicensingBillingForm from '../components/PosLicensingBillingForm';
import TableActionButton from '../components/TableActionButton';
import { TextWidget } from '../components/Widget'
//import { datatype } from 'faker';
import Switch from "react-switch";
import { MDBDataTable } from 'mdbreact';

class OutstandingLicensingBillingPage extends React.Component {
    _isMounted = true
    state = {
        list: [],
        isEdit: false,
        modal: false,
        editItem: null,
        company_id: null
    };

    toggle = (action, id) => () => {
        let obj = null;

        if (id !== undefined || id !== null) {
            obj = this.state.list.find(e => e.id == id);
        }

        return this.setState({
            modal: !this.state.modal,
            isEdit: action === 'ADD' ? false : true,
            editItem: obj,
            company_id: obj.company_id
        });
    };

    update = data => {
        if (window.confirm("Do you really want to save changes?")) {
            const user = StorageService.getSession('user_info');
            const url = process.env.REACT_APP_UNITY_API2_URL;
            const formData = {
            session_key: process.env.REACT_APP_UNITY_API2_KEY,
                id: data.id,
                currency: data.currency,
                amount: data.amount,
                description: data.description,
                billing_date: data.billing_date,
                due_date: data.due_date,
                admin_email: data.admin_email,
                payment_status: data.payment_status,
                update_by: user.email
            };
        
            axios
            .post(url + ':3000/v1/user/billing/update', formData)
            .then(response => {
                const result = response.data;
                if (result.error == true) {
                this.notificationSystem.addNotification({
                    title: <MdClear />,
                    message: result.message,
                    level: 'error',
                    position: 'br',
                    autoDismiss: 4,
                    dismissible: 'click',
                });
                return;
                }
        
                this.setState({
                modal: false,
                isEdit: false,
                editItem: null
                });
        
                this.notificationSystem.addNotification({
                title: <MdDone />,
                message: 'Billing updated successfully.',
                level: 'success',
                position: 'br',
                autoDismiss: 4,
                dismissible: 'click',
                });
                this.get();
            })
            .catch(error => {
                alert(error);
            });
        }
    };

    delete = (id) => {
        if (window.confirm("Do you really want to delete?"))  {
            const user = StorageService.getSession('user_info');
            const url = process.env.REACT_APP_UNITY_API2_URL;
        
            const data = {
                session_key: process.env.REACT_APP_UNITY_API2_KEY,
                id: id,
                delete_by: user.email
            };
        
            axios
            .post(url + ':3000/v1/user/billing/delete', data)
            .then(response => {
                const result = response.data;
        
                if (result.error == 'true' && result.message != 'Success') {
                alert(result.message);
                return;
                }
        
                this.setState({
                    modal: false,
                    isEdit: false,
                    editItem: null
                });
        
                this.notificationSystem.addNotification({
                    title: <MdDone />,
                    message: 'Billing deleted successfully.',
                    level: 'success',
                    position: 'br',
                    autoDismiss: 4,
                    dismissible: 'click',
                });
        
                this.get();
            })
            .catch(error => {
                alert(error);
            });
        }
        
    };

    get = () => {
        const url = process.env.REACT_APP_UNITY_API2_URL;

        const data = {
            session_key: process.env.REACT_APP_UNITY_API2_KEY
        };

        axios
        .post(url + ':3000/v1/user/billing/outstanding', data)
        .then(response => {
            const result = response.data;

            if (result.error == 'true' && result.message != 'Success') {
                alert(result.message);
                return;
            }
            for(let i of result.data) {
                i.action = <div className='d-flex'>
                    <Button className="theme-button theme-button-secondary mr-2" onClick={this.toggle('EDIT', i.id)}>Edit</Button>
                    <Button className="theme-button theme-button-primary-light mr-2" onClick={() => this.delete(i.id)}>Delete</Button>
                </div>
            }
            if (this._isMounted) {
                this.setState({ list: result.data});
            }
        })
        .catch(error => {
            alert(error);
        });
    };

    componentDidMount() {
        this.get();
    }

    componentWillUnmount() {
        this._isMounted = false
    }

  render() {
    return (
      <Page
        title="Outstanding Billing"
        breadcrumbs={[{ name: 'Outstanding Billing', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Card>
          <CardBody>
            <MDBDataTable data={{
                columns: [
                    {
                        label: 'ID',
                        field: 'order_id',
                        sort: 'asc',
                    },
                    {
                        label: 'Status',
                        field: 'payment_status',
                        sort: 'asc',
                    },
                    {
                        label: 'Billing Date',
                        field: 'billing_date',
                        sort: 'asc',
                    },
                    {
                        label: 'Due Date',
                        field: 'due_date',
                        sort: 'asc',
                    },
                    {
                        label: 'Amount',
                        field: 'amount',
                        sort: 'asc',
                    },
                    {
                        label: 'Currency',
                        field: 'currency',
                        sort: 'asc',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        sort: 'asc',
                    },
                    {
                        label: 'Admin',
                        field: 'admin_email',
                        sort: 'asc',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sort: 'disabled',
                    },
                ],
                rows: this.state.list
            }}
                responsive
                searching={false}
                order={['order_id', 'asc']}
                displayEntries={false}
                entries={20}
                noBottomColumns
                noRecordsFoundLabel="No records"
                pagesAmount={5}
                paginationLabel={["<", ">"]}
                disableRetreatAfterSorting
            />
          </CardBody>
        </Card>

        <Modal isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          centered>
          <PosLicensingBillingForm
            isEdit={this.state.isEdit}
            item={this.state.editItem}
            company_id={this.state.company_id}
            billing={this.state.billing}
            toggle={this.toggle}
            create={this.create}
            update={this.update} />
        </Modal>
      </Page>
    );
  }
}
export default OutstandingLicensingBillingPage;
